module.exports = __webpack_public_path__ + "BulletPoint-TTK4Ecj.svg";